export const ADMIN_DASHBOARD_ROLE_KEY = "adminDashboardRole";
export const DASHBOARD_ROLE_FULL = "full";
export const DASHBOARD_ROLE_STORE_PRODUCTS = "store_products";

const STORE_PRODUCTS_PATH_PREFIXES = [
  "/dashboard/store/products",
  "/dashboard/store/add-product",
  "/dashboard/store/edit-product",
];

export function getAdminDashboardRole() {
  const role =
    localStorage.getItem(ADMIN_DASHBOARD_ROLE_KEY) ||
    sessionStorage.getItem(ADMIN_DASHBOARD_ROLE_KEY) ||
    DASHBOARD_ROLE_FULL;
  return role === DASHBOARD_ROLE_STORE_PRODUCTS
    ? DASHBOARD_ROLE_STORE_PRODUCTS
    : DASHBOARD_ROLE_FULL;
}

export function setAdminDashboardRole(role) {
  const value =
    role === DASHBOARD_ROLE_STORE_PRODUCTS
      ? DASHBOARD_ROLE_STORE_PRODUCTS
      : DASHBOARD_ROLE_FULL;
  if (localStorage.getItem("authToken")) {
    localStorage.setItem(ADMIN_DASHBOARD_ROLE_KEY, value);
    sessionStorage.removeItem(ADMIN_DASHBOARD_ROLE_KEY);
  } else if (sessionStorage.getItem("authToken")) {
    sessionStorage.setItem(ADMIN_DASHBOARD_ROLE_KEY, value);
    localStorage.removeItem(ADMIN_DASHBOARD_ROLE_KEY);
  } else {
    localStorage.setItem(ADMIN_DASHBOARD_ROLE_KEY, value);
  }
}

export function clearAdminDashboardRole() {
  localStorage.removeItem(ADMIN_DASHBOARD_ROLE_KEY);
  sessionStorage.removeItem(ADMIN_DASHBOARD_ROLE_KEY);
}

export function isStoreProductsOnlyAdmin() {
  return getAdminDashboardRole() === DASHBOARD_ROLE_STORE_PRODUCTS;
}

export function isDashboardPathAllowed(pathname) {
  if (!isStoreProductsOnlyAdmin()) return true;
  if (pathname === "/dashboard" || pathname === "/dashboard/") {
    return false;
  }
  return STORE_PRODUCTS_PATH_PREFIXES.some((prefix) =>
    String(pathname || "").startsWith(prefix)
  );
}

export function getDefaultDashboardPath() {
  return isStoreProductsOnlyAdmin()
    ? "/dashboard/store/products"
    : "/dashboard";
}
